import React from "react";

import TFGPT1 from "./TFGPT1";
import Icon1 from "../assets/icons/Icon";

interface SearchBarFoldersProps {
  orgData?: any;
  value: string;
  setValue: (value: string) => void;
  onAction?: () => void;
  searchEvents?: boolean;
  setSeachType?: (type: string) => void;
  placeholder?: string;
  options?: any[];
}

function BasicSearchBar({
  orgData,
  value,
  setValue,
  onAction = () => {},
  placeholder = "Chercher parmi les dossiers ...",
  options = [],
}: SearchBarFoldersProps) {
  return (
    <div
      className={`bg-[#EEEEEE] 
      rounded-3xl  w-fit px-3 py-1 h-fit`}
    >
      <div className="flex flex-row gap-2 w-full items-center">
        <TFGPT1
          options={options}
          placeholder={placeholder}
          inputValue={value}
          setInputValue={setValue}
          onAction={onAction}
          width={400}
          start_only={false}
        ></TFGPT1>
        <div className="cursor-pointer px-2">
          <Icon1 icon_name="search" fill="grey"></Icon1>
        </div>
      </div>
    </div>
  );
}

export default BasicSearchBar;
